import React from "react";

const LazyDashboard = React.lazy(() => import("./Dashboard").then((module) => ({ default: module.Dashboard })));

export default LazyDashboard;
